import {Component, OnInit, AfterViewInit, Input, EventEmitter, ElementRef, OnChanges, SimpleChanges} from '@angular/core';


@Component({
	selector: 'component-datestates-bar',
	templateUrl: './component.dateStates.html',
	styleUrls: ['./component.dateStates.css']
})

export class ComponentDatestates implements OnInit, AfterViewInit {
  @Input() isPC: boolean;
  @Input() isCamp: boolean;
  @Input() openTime: string;
  @Input() courseOverdue: boolean;

  isShowInner: boolean = false;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    
  }

  ngOnChanges(){
    
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/component-ui/date-states/component.dateStates.ts